<template>
  <div class="gl-digital-flop">
    <span v-for="i in numbers" :class="`${i==','?'string-flop':'number-flop'}`">{{i}}</span>
  </div>
</template>
<script>
import CRender from '@jiaminghi/c-render'

import '@jiaminghi/charts/lib/extend/index'

export default {
  name: 'DigitalFlop',
  props: {
    config: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      renderer: null,

      defaultConfig: 0,

      mergedConfig: 0,

      graph: null,
      numbers:[]
    }
  },
  watch: {
      config () {
        const { update } = this
        update()
      }
  },
  methods: {
    init () {
      const { mergeConfig,initValue } = this
      mergeConfig()
      initValue()
    },
    mergeConfig () {
      const { defaultConfig, config } = this
      this.mergedConfig = config == null ? defaultConfig : config
    },
    initValue () {
      const number = this.mergedConfig
      const numberString = number.toString().split('').reverse()
      const segs = []
      while (numberString.length) segs.push(numberString.splice(0, 3).join(''))
      const numberFormatter = segs.join(',').split('').reverse().join('')
      this.numbers = numberFormatter.split('')
      
    },
    update(){
        const { mergeConfig,initValue } = this
        mergeConfig()
        initValue ()
    }
  },
  mounted () {
    const { init } = this
    init()
  }
}
</script>
<style lang="scss" type="text/scss">
    .gl-digital-flop {
            width: 100%;
            height: 100%;
            justify-content: center;
            span{
                font-family: Helvetica-Bold;
                font-size: 57.6px;
                line-height: 70px;
                color: #FFFFFF;
                letter-spacing: 0px;
                text-align: center;
                margin: 0 5px;
            }
            .number-flop{
                display: block;
                width: 50px;
                height: 70px;
                background: #EA2C5D;
                border-radius: 5px;
            }
    }

</style>